import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { TokenInterceptor } from './interceptor/token.interceptor';
import { ErrorInterceptor } from './interceptor/error.interceptor';
import { CookieService } from 'ngx-cookie-service';
import { LoaderInterceptor } from './interceptor/loader.interceptor';
import { NavClickTrackDirective } from './analytics/navClickTrack.directive';

@NgModule({
  imports: [CommonModule],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    CookieService,
  ],
  declarations: [NavClickTrackDirective],
  exports: [NavClickTrackDirective],
})
export class ApiSharedModule {}
